export default "__VITE_ASSET__391cca24__"